module.exports = __webpack_public_path__ + "media/images/newsletter-bg-e029ec8b0500e004491f020fc94a63d1.svg";